import { TableColumnType } from "antd";
import React, { ReactElement } from "react";
import { StateSwitch } from "../../compnents/widgets/StateSwitch";
import {
  Department,
  getDepartmentCategoryName,
  getDepartmentSubCategoryName,
} from "../../models/department";
import { Dimen } from "../../models/dimen";

export const columns = (
  toggleStatus: (department: Department) => void,
  startIndex: number
): TableColumnType<Department>[] => {
  return [
    {
      title: "序号",
      dataIndex: "order",
      align: "center",
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "科室代码",
      dataIndex: "code",
      align: "center",
      width: Dimen.Code,
      ellipsis: true,
    },
    {
      title: "科室名称",
      dataIndex: "name",
      align: "center",
      width: Dimen.DepartmentName,
      ellipsis: true,
    },
    {
      title: "科室类别",
      dataIndex: "category",
      align: "center",
      width: Dimen.Category,
      render: (_, d) =>
        d.id === "" ? "" : getDepartmentCategoryName(d.category),
    },
    {
      title: "科室类型",
      dataIndex: "subCategory",
      align: "center",
      ellipsis: true,
      render: (_, d) =>
        d.id === ""
          ? ""
          : d.subCategory
              .map((s) => getDepartmentSubCategoryName(s))
              .join("，"),
    },
    {
      title: "注销状态",
      key: "actions",
      align: "center",
      width: Dimen.Actions,
      render: function DepartmentStatus(_, d): ReactElement {
        return (
          <StateSwitch
            value={d.status === 1}
            onChange={() => toggleStatus(d)}
          />
        );
      },
    },
  ];
};
